import { connect } from 'react-redux';
import { Placement } from '@noths/polaris-client-ribbons-design-system';
import { selectExperiments } from '@noths/polaris-client-user-configuration';

import { PDP_MVP_ABC_VARIANT_2 } from 'src/constants/experiments';
import { addItemToBasket } from 'src/redux/basket';
import { ReduxApplicationState } from 'src/redux/combinedReducer';
import {
  actions as personalisationActions,
  InteractionErrorTrackingEvent,
  selectOutstandingPersonalisations,
  selectPersonalisationFromBasket,
  submitPersonalisationForm,
} from 'src/redux/personalisation';
import { actions as productActions } from 'src/redux/product';
import { actions as reviewsActions } from 'src/redux/reviews';
import { selectFavouriteProduct, selectProductDeliveryByEvent } from 'src/redux/selectors';
import { AppThunkDispatch } from 'src/redux/store';
import { ProductInfo } from '../components/ProductInfo';
import { actions } from '../modules';
import { GAEventsMap } from '../tracking/eventsMap';

const onCartGoToBasket = () => {
  /* 
    Applying a short circuit to bypass the redux middleware and call the GAEventsMap directly for onCartGoToBasket.
    This is to ensure a redirect to cart page as there is a bug with middleware sometimes not firing:
    https://notonthehighstreet.atlassian.net/wiki/spaces/F/pages/3430940681/FFA-1564
  */
  // @ts-ignore
  GAEventsMap[actions.onCartGoToBasket.type]();
};

const mapStateToProps = (state: ReduxApplicationState) => ({
  basket: state.basket.basket,
  deliveryByEvent: selectProductDeliveryByEvent(state),
  editItem: selectPersonalisationFromBasket(state),
  hideAddToCartPlacement: state.richRelevance?.[Placement.AddToCart]?.products === null,
  isCartModalOpen: state.productInfo.isCartModalOpen,
  isPersonalisationOptionsExpanded: state.personalisation.isPersonalisationOptionsExpanded,
  outstandingSelections: selectOutstandingPersonalisations(state),
  product: selectFavouriteProduct(state),
  richRelevanceSessionId: state.userConfiguration.richRelevanceSessionId,
  shouldShowDeliveryBlock: !selectExperiments(state)?.includes(PDP_MVP_ABC_VARIANT_2),
  shouldShowPersonalisationValidationErrors:
    state.personalisation.shouldShowPersonalisationValidationErrors,
  trackedEvents: state.personalisation.trackedEvents,
  userConfiguration: state.userConfiguration,
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
  addToBasket: () => dispatch(addItemToBasket()),
  changeQuantity: (payload: { quantity: number; isValid: boolean }) =>
    dispatch(productActions.changeQuantity(payload)),
  toggleExpanded: () => dispatch(personalisationActions.toggleExpanded()),
  openCartModal: () => dispatch(actions.openCartModal()),
  trackErrorInteraction: (payload: InteractionErrorTrackingEvent) =>
    dispatch(personalisationActions.trackInteractionError(payload)),
  onCartGoToBasket: onCartGoToBasket /* () => dispatch(actions.onCartGoToBasket()), */,
  onCartModalClose: () => {
    dispatch(actions.closeCartModal());
    dispatch(actions.onCartContinueShopping());
  },
  onProductReviewsReadReviews: () => dispatch(reviewsActions.onProductReviewsReadReviews()),
  submitPersonalisationForm: () => dispatch(submitPersonalisationForm()),
});

export const ProductInfoContainer = connect(mapStateToProps, mapDispatchToProps)(ProductInfo);
